import React from "react";
import WelcomeBox from "../WelcomeBox";
import ContainerOne from "../Home/ContainerOne";
import { useWallet } from '../WalletProvider';
import VerificationTab from "./VerificationTab";
import TronVerificationTab from "./TronVerificationTab";
import Header from '../common/Header'

function Verify() {
    const {currencyDetails } = useWallet();
  return (
    <>
    <Header/>
        <section className="section2" id="" data-section="section1">
            <div className="container">
                <div className="caption">
                <WelcomeBox/>

                    <div className="btm-form">
                        <ContainerOne/>
                        <div className="progress-wrap">
                            <div className="line-progress-bar">
                                <div className="line"></div>
                                <ul className="checkout-bar">
                                    <li key="1" className="progressbar-dots active"><span>Prepare</span></li>
                                    <li key="2" className="progressbar-dots"><span>Approve</span></li>
                                    <li key="3"className="progressbar-dots"><span>Multidrop</span></li>
                                </ul>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-8 col-12 m-auto">
                                <form action="" id="booking-form">
                                    <div className="tab-content">
                                        {currencyDetails.networkType === "TRON" ? <TronVerificationTab/> :  <VerificationTab/> }
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  );
}

export default Verify;
